export const isCpfValid = (cpfString?: number | string): boolean => {
  if (typeof cpfString === 'number') {
    cpfString = cpfString.toString();
  }

  if (!cpfString) {
    cpfString = '';
  }

  const strCPF = cpfString.replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, '');

  let sum = 0;
  let rest: number;

  if (strCPF === '00000000000') {
    return false;
  }

  for (let tie = 1; tie <= 9; tie++) {
    sum = sum + parseInt(strCPF.substring(tie - 1, tie), 10) * (11 - tie);
  }

  rest = (sum * 10) % 11;

  if (rest === 10 || rest === 11) {
    rest = 0;
  }

  if (rest !== parseInt(strCPF.substring(9, 10), 10)) {
    return false;
  }

  sum = 0;

  for (let tie = 1; tie <= 10; tie++) {
    sum = sum + parseInt(strCPF.substring(tie - 1, tie), 10) * (12 - tie);
  }

  rest = (sum * 10) % 11;

  if (rest === 10 || rest === 11) {
    rest = 0;
  }

  if (rest !== parseInt(strCPF.substring(10, 11), 10)) {
    return false;
  }

  return true;
};
